import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CalendarContainer } from './styles';
import { CalendarBar } from './CalendarBar';
import DayTable from './DayTable';
import LastRow from '../../components/shared/LastRow';
import ConfigManager from '../../common/configManager/configManager';
import { getQuery } from '../../helpers';
import { isHideStandingLink } from '../../common/rcs_gaz_mc_core_FE';


class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      betting: 0,
    };
  }

  componentWillMount() {
    //this.loadBet();
  }

  componentDidMount() {
    this.resizeCallback();
    const { actions, isFootballSerieB } = this.props;
    if (!isFootballSerieB) {
      const day = getQuery(document.location);
      const { sportId, competitionId, seasonId } = window.matchcenterPage;
      if (day && day.giornata) {
        actions.getParamDayCalendar(sportId, competitionId, parseInt(day.giornata, 10), seasonId);
      } else {
        actions.getCalendar(sportId, competitionId, seasonId);
      }
    }
    window.addEventListener('resize', this.resizeCallback);
  }

  componentDidUpdate() {
    window.addEventListener('load', this.boolHighlights);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= this.dynamicBreakPointWindow(process.env.REACT_APP_SITE),
    });
  };

  boolHighlights = () => {
    //console.log('---------boolHighlights------>', document.querySelectorAll('.isAnHighlights').length);
    if (document.querySelector('.myHighlights')) {
      if (document.querySelectorAll('.isAnHighlights').length === 0) {
        document.querySelector('.myHighlights').style.display = 'none';
      } else {
        document.querySelector('.myHighlights').style.display = 'initial';
      }
    }
  };


  dynamicBreakPointWindow = (site) => {
    if (site === 'gazzetta') {
      return 1023;
    } else if (site === 'fcinter' || site === 'calcionapoli1926' || site === 'forzaroma') {
      return 980;
    } else if (site === 'corriere') {
      return 767;
    } else {
      return 1023;
    }
  };

  corriereLink = () => {
    let returnedLink = '';
    if (process.env.REACT_APP_SITE === 'corriere') {
      returnedLink = '/sport';
    }
    return returnedLink;
  };


  loadBet = () => {
    window.addEventListener('message', (e) => {
      if (e.data === 'mcQuoteTriggerAdv') {
        if (typeof window.top.matchCenterVarDfp !== 'undefined') {
          if (this.state.betting === 0) {
            //console.log('valore bet:', top.matchCenterVarDfp);
            let betType;
            if (window.top.matchCenterVarDfp === '1') {
              betType = 'sportpesa';
            } else if (window.top.matchCenterVarDfp === '2') {
              betType = 'planetwin';
            } else if (window.top.matchCenterVarDfp === '3') {
              betType = 'lottomatica';
            } else if (window.top.matchCenterVarDfp === '4') {
              betType = 'bet365';
            } else if (window.top.matchCenterVarDfp === '5') {
              betType = 'unibet';
            }
            if (process.env.REACT_APP_SITE !== 'corriere') {
              this.props.actions.getBetMatches(window.matchcenterPage.sportId, window.matchcenterPage.competitionId, betType);
              this.setState({
                betting: window.top.matchCenterVarDfp,
              });
              if (document.querySelector('.TeamHeaderWrapper')) {
                document.querySelector('.TeamHeaderWrapper').style.marginBottom = `${this.state.isMobile ? '100px' : '70px'}`;
              }
            }
          }
        }
      }
    });
  };

  render() {
    const {
      actions, dictionary, calendar, hasHighlights, betMatch, isFootballSerieB, isUefaCompetitionChampionship,
    } = this.props;
    const { sportId, competitionId } = window.matchcenterPage;
    const { isMobile, betting } = this.state;
    const currentDay = calendar && (isUefaCompetitionChampionship ? calendar.get('lastSubPhase') : calendar.get('currentDay'));
    const games = calendar && calendar.get('games');

    return (
      <CalendarContainer>
        {currentDay &&
        <CalendarBar
          dictionary={dictionary}
          actions={actions}
          currentDay={currentDay}
          hasHighlights={hasHighlights}
          isMobile={isMobile}
        />
        }
        {games && games.map((c, index) => (
          <DayTable
            matchDate={c.get('date')}
            matches={isUefaCompetitionChampionship && c.get('matches') ? c.getIn(['matches', 0, currentDay]) : c.get('matches')}
            dictionary={dictionary}
            hasHighlights={hasHighlights}
            isMobile={isMobile}
            actions={actions}
            key={index}
            betMatch={betMatch}
            betType={betting}
          />
          ))
        }
        {!isFootballSerieB && !isUefaCompetitionChampionship &&
        <React.Fragment>
          {process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ?
            games && games.size > 0 &&
            <LastRow
              linkLabel1="Risultati Live"
              linkLabel2={isHideStandingLink(sportId, competitionId) ? null : 'Classifica'}
              linkPath1={`${this.corriereLink()}/risultati-live/`}
              linkPath2={`${this.corriereLink()}${dictionary.standingsLink[ConfigManager.getEnv()]}${dictionary.competitionLink[Number(competitionId)]}/classifica/`}
            />
            : <LastRow
              linkLabel1="Classifica Marcatori"
              linkLabel2={isHideStandingLink(sportId, competitionId) ? null : 'Classifica'}
              linkPath1={`${dictionary.gazzanetStandingsLink[ConfigManager.getEnv()]}${dictionary.competitionLink[Number(competitionId)]}/marcatori/`}
              linkPath2={`${dictionary.gazzanetStandingsLink[ConfigManager.getEnv()]}${dictionary.competitionLink[Number(competitionId)]}/classifica/`}
            />
          }
        </React.Fragment>
        }
      </CalendarContainer>
    );
  }
}

Calendar.propTypes = {
  dictionary: PropTypes.any,
  actions: PropTypes.any,
  calendar: PropTypes.any,
  hasHighlights: PropTypes.bool,
  betMatch: PropTypes.any,
  isFootballSerieB: PropTypes.bool,
  isUefaCompetitionChampionship: PropTypes.bool,
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/containers/Calendar/index.js